import React from 'react';

export class SearchResultSummary extends React.PureComponent {
    renderResultCount() {
        return (this.props.searchResult.length > 0) ?
            (<span>Mostrando <strong>{this.props.searchResult.length}</strong>
                &nbsp;de un total de <strong>{this.props.searchResultRange.length} resultados</strong></span>) :
            (null);
    }

    renderNoResultsAlert() {
        return (this.props.searchResult.length === 0) ?
            (<div className="alert alert-info">
                <h4>No se encontraron resultados</h4>
                Modifica tu b&uacute;squeda y prueba de vuelta!
            </div>) :
            (null);
    }

    render() {
        if (this.props.searchResult) {
            return (
                <div className="searchResultSummary">
                    <div className="col-md-12">
                        {this.renderResultCount()}
                        {this.renderNoResultsAlert()}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ../components/SearchResultSummary/SearchResultSummary.jsx